import type { SendGtmEvent } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { BuyNowEventInteractiveTags } from '@/modules/shared/utils/gtmEvents/buyNowTypes';

export const CONTINUE_EVENT: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag': BuyNowEventInteractiveTags.PayButton
  }
};

export const TOTALS_PRICES_TO_SHOW = {
  showTotalPriceCenco: true,
  showTotalPrice: true
};
